import { SearchContextProvider } from '@dreamstack/search'
import type { FunctionComponent } from 'react'
import type { NewsHubProps } from './NewsHub';
import { NewsHub } from './NewsHub'

export const NewsHubWithSearch: FunctionComponent<React.PropsWithChildren<NewsHubProps>> = ({
  ...newsHubProps
}) => {
  return (
    <>
      <SearchContextProvider indexType={'news'}>
        <NewsHub {...newsHubProps} />
      </SearchContextProvider>
    </>
  )
}
